import { MdClose } from 'react-icons/md';

const PurchaseOrderSuccessModal = (props: { isOpen: any; onClose: any }) => {
    const { isOpen, onClose } = props;

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/30 backdrop-blur-sm">
            <div className="relative z-[1002] w-full max-w-[500px] p-4">
                <div className="relative rounded-xl border border-leadrs-stroke bg-white px-8 py-10 shadow-lg">
                    <button className="absolute right-4 top-4" onClick={onClose}>
                        <MdClose size={20} className="text-leadrs-text-soft hover:text-leadrs-text transition-colors" />
                    </button>
                    <p className="text-center font-crimson text-2xl font-semibold text-leadrs-text">
                        Ordre d&apos;achat déposé !
                    </p>
                    <p className="mt-5 text-center font-geist text-sm text-leadrs-text-soft">
                        Merci d&apos;avoir déposé votre ordre d&apos;achat de leads.
                    </p>
                    <p className="mt-2 text-center font-geist text-sm text-leadrs-text-soft">
                        Nous vous tiendrons informe des qu&apos;un vendeur repond a votre demande.
                    </p>
                    <p className="mt-6 text-center font-geist text-sm font-medium text-leadrs-text">
                        L&apos;equipe Leadrs
                    </p>
                </div>
            </div>
        </div>
    );
};
export default PurchaseOrderSuccessModal;
